import Vue from 'vue';
import VueRouter from 'vue-router';
import Page from '../views/Page.vue';

Vue.use(VueRouter);

export default class Router {
  constructor(pages) {
    this.pages = pages;
  }

  buildRoutes() {
    return this.pages.map((page) => ({
      path: page.homePage ? '/' : `/${page.url}`,
      name: page.pageName,
      component: Page,
      props: { pageName: page.pageName },
    }));
  }

  getRouter() {
    return new VueRouter({
      routes: this.buildRoutes(),
      mode: 'history',
    });
  }
}
